import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Headline3DisableProps extends ITextBoxProps {}

export const TextBoxMaxLine1Headline3Disable = ({
  title,
  color = Colors.TEXT_ICON_TERTIARY,
  font = TextBoxTypes.Headline3,
  alignment = TextAligning.Left,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Headline3DisableProps): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
